module.exports = __webpack_public_path__ + "img/rich-checked-ms.565bb19f.png";